import { Controller } from '@hotwired/stimulus';
import { every } from 'lodash';

export default class extends Controller {
  static targets = ['button']

  connect() {
    this.inputs = this.element.querySelectorAll('input, select');

    this.element.addEventListener('change', this.handleChange.bind(this));
    this.element.addEventListener('input', this.handleChange.bind(this));

    this.handleChange();
  }

  handleChange(event) {
    const valid = every(this.inputs, i => i.checkValidity());

    this.buttonTarget.toggleAttribute('disabled', !valid);

    const input = event?.target;
    // PasswordInput renders its own requirements message inside its show/hide wrapper.
    if (!input?.matches('input:not([type=checkbox]):not([type=radio]):not(#password-input), select')) return;

    // Wait until the user leaves the field to flag it, but clear it while they type once it's flagged.
    if (event.type === 'change' || input.classList.contains('is-invalid')) this.showError(input);
  }

  // Empty fields stay quiet so a fresh form isn't covered in "required" errors, unless already flagged.
  showError(input) {
    let message = '';

    if (!input.checkValidity()) {
      if (!input.value && !input.classList.contains('is-invalid')) return;

      message = (input.value && input.title) || input.validationMessage;
    }

    let feedback = input.nextElementSibling;

    if (!feedback?.classList.contains('invalid-feedback')) {
      if (!message) return;

      feedback = document.createElement('div');
      feedback.className = 'invalid-feedback';
      feedback.setAttribute('aria-live', 'polite');
      input.after(feedback);
    }

    feedback.id ||= `${input.id || input.name}-feedback`;
    const describedBy = new Set((input.getAttribute('aria-describedby') || '').split(' ').filter(Boolean));

    if (message) {
      describedBy.add(feedback.id);
      input.setAttribute('aria-invalid', 'true');
    } else {
      describedBy.delete(feedback.id);
      input.removeAttribute('aria-invalid');
    }

    if (describedBy.size) input.setAttribute('aria-describedby', [...describedBy].join(' '));
    else input.removeAttribute('aria-describedby');

    input.classList.toggle('is-invalid', Boolean(message));
    feedback.textContent = message;
  }
}
